export default "__VITE_ASSET__d83eaa86__"